
import { useNavigate } from 'react-router-dom';

export default function StudentsCTASection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-gradient-to-br from-blue-900 via-indigo-900 to-purple-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Shape the Future of Healthcare?
          </h2>
          <p className="text-xl text-blue-100 mb-8 leading-relaxed">
            Join CPVA Students today and become part of a community that's revolutionizing the intersection of pharmacy and veterinary medicine. Your journey to professional excellence starts here.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">2,500+</div>
              <div className="text-blue-200">Active Student Members</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">15</div>
              <div className="text-blue-200">Partner Universities</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">95%</div>
              <div className="text-blue-200">Graduate Employment Rate</div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/membership')}
              className="bg-white text-blue-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Join CPVA Students
            </button>
            <button
              onClick={() => navigate('/programs')}
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-blue-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              Explore Programs
            </button>
            <button
              onClick={() => navigate('/news')}
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-blue-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              Stay Updated
            </button>
          </div>

          <div className="mt-12 text-blue-100">
            <p className="text-lg">
              Questions? Contact our Student Services team at{' '}
              <a href="mailto:students@cpva.ca" className="text-white underline hover:text-blue-200">
                students@cpva.ca
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
